export function isStringArray(data: unknown): data is string[] {
    return Array.isArray(data) && data.every((item) => typeof item === 'string');
}

export function strToNum(str: string): number;
export function strToNum(str?: string): number | undefined;
export function strToNum(str?: string) {
    if (!str)
        return undefined;

    const num = parseInt(str);

    return isNaN(num) ? undefined : num;
}